
import crud from "./_crud";
import { callApi } from 'utils/api';

const actions = crud('role', 'el rol', 'los roles');

const updatePermisitions = ({ id, permisitions }) => {
   return async (dispatch, getState) => {
      const state = getState();

      const res = await callApi(`/role/${id}/permisitions`, {
         method: 'PATCH',
         body: JSON.stringify(permisitions),
         headers: {
            Authorization: state.app.user.token
         },
         successMessage: `Se actualizó los permisos correctamente.`
      });
      dispatch({
         type: `UPDATE_ROLE`,
         response: res.body
      })

   };
};

export default { ...actions, updatePermisitions }